import { render, staticRenderFns } from "./PendingOrder.vue?vue&type=template&id=2b5c28d2"
import script from "./PendingOrder.vue?vue&type=script&lang=ts"
export * from "./PendingOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports